import React from 'react'
import ReactDOM from 'react-dom'

import { init } from '@navent-jobs/config'
import moment from 'moment'
import 'moment/locale/es'

import './i18n'
import App from './App'
import { FirebaseOptions } from 'firebase/app'

/**
 * Interfaz global para el window.xxxx
 */
declare global {
  interface Window {
    GOOGLE_LOGIN_KEY_COMPANY: string
    GOOGLE_MAPS_KEY: string
    firebaseConfig: FirebaseOptions
  }
}

/**
 *  Initialize moment with ES locale
 */
moment.locale('es')

/**
 *  Initialize API client
 */
init({ baseURL: process.env.REACT_APP_API_BASE_URL || '/' })

// eslint-disable-next-line no-console
console.log(
  // eslint-disable-next-line max-len
  '%c\n                                               \n      ██╗ █████╗ ██████╗ ██╗███╗  ██╗████████╗ \n      ██║██╔══██╗██╔══██╗██║████╗ ██║╚══██╔══╝ \n      ██║██║  ██║██████╔╝██║██╔██╗██║   ██║    \n ██╗  ██║██║  ██║██╔══██╗██║██║╚████║   ██║    \n ╚█████╔╝╚█████╔╝██████╔╝██║██║ ╚███║   ██║    \n  ╚════╝  ╚════╝ ╚═════╝ ╚═╝╚═╝  ╚══╝   ╚═╝    \n                                               \n     TRABAJANDO PARA QUE CONSIGAS LABURO!      \n',
  'font-family:monospace;color:#0A26EE;font-size:12px;'
)
/* 
     ██╗ █████╗ ██████╗ ██╗███╗  ██╗████████╗
     ██║██╔══██╗██╔══██╗██║████╗ ██║╚══██╔══╝
     ██║██║  ██║██████╔╝██║██╔██╗██║   ██║
██╗  ██║██║  ██║██╔══██╗██║██║╚████║   ██║
╚█████╔╝╚█████╔╝██████╔╝██║██║ ╚███║   ██║
 ╚════╝  ╚════╝ ╚═════╝ ╚═╝╚═╝  ╚══╝   ╚═╝
*/

ReactDOM.render(<App />, document.getElementById('root'))
